import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const CloseXsmall = (props: SvgIconT.Props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path d="M13.071 13.289l-2.828-2.828 2.828-2.828-.707-.707-2.828 2.828-2.828-2.828-.707.707 2.828 2.828-2.828 2.828.707.707 2.828-2.828 2.828 2.828z"></path>
  </SvgIcon>
);

export default CloseXsmall;
